// extracted by mini-css-extract-plugin
module.exports = {"body":"WpPost_body__1n6Am"};